import { LayersDictState } from '@/redux/layers/layers.types';
import { LayerRectAdapter } from '@/utils/layer/LayerRectAdapter';

export default function setLayerRect({
  layerId,
  layers,
  layerRect,
}: {
  layerId: number;
  layers: LayersDictState;
  layerRect: LayerRectAdapter;
}): void {
  const layer = layers[layerId];
  if (!layer) {
    return;
  }
  layer.rects[layerRect.getOriginalId()] = layerRect;
}
